<div class="center-align margin-top-20 margin-bottom-20"
    *ngIf="settlementDataSource.data.length === 0 && networkCallInProgress">
    <mat-spinner [diameter]="35"></mat-spinner>
</div>
<div *ngIf="settlementDataSource.data.length > 0">
    <mat-table #table [dataSource]="settlementDataSource" class="finzyfont margin-top-20 margin-bottom-20"
        multiTemplateDataRows>
        <ng-container matColumnDef="loanId">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px"> Loan Id<br>(Rating and Tenure)
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="padding-right: 30px"> <span>
                    <span>{{element.loanId}}</span> <br><span class="small-text">({{element.rating}})
                        ({{element.tenure}} MONTH)</span>
                </span></mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="investmentInLoan">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px"> Total Investment in Loan <br>(Date of
                Disbursal)
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="padding-right: 20px">
                <span> <span>
                        <app-indian-currency-formatter [amount]="element.investmentInLoan">
                        </app-indian-currency-formatter>
                    </span> <br><span class="small-text">{{element.loanDisbursalDate}}</span></span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="grossCashFlowReceived">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">Gross Cashflow Received Before Settlement
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px">
                <app-indian-currency-formatter [amount]="element.grossCashFlowReceivedBeforeSettlement">
                </app-indian-currency-formatter>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="principalOutstandingBeforeSettlement">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">Principal Outstanding Before Settlement
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px">
                <app-indian-currency-formatter [amount]="element.principalOutstandingBeforeSettlement">
                </app-indian-currency-formatter>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px"> Date of Settlement</mat-header-cell>
            <mat-cell *matCellDef="let element" style="padding-right: 30px">
                {{element.settlementDate}}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="settlementPrincipal">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">Settlement Amount</mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px">
                <app-indian-currency-formatter amount="{{element.settlementAmount}}"></app-indian-currency-formatter>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="grossCashFlowReceivedPostSettlement">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">Gross Cashflow Received Post Settlement
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px">
                <app-indian-currency-formatter amount="{{element.grossCashFlowReceivedPostSettlement}}">
                </app-indian-currency-formatter>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="settlementPrincipalWrittenOff">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">Principal Written off Post Settlement
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px">
                <app-indian-currency-formatter amount="{{element.settlementPrincipalWrittenOff}}">
                </app-indian-currency-formatter>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="accordion_arrow">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element" style="justify-content: flex-end;max-width: 46px;">
                <mat-icon style="font-family: 'Material Icons';font-size: 18px;">{{element == expandedElement ?
                    'arrow_drop_up' : 'arrow_drop_down'}}
                </mat-icon>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let element">
                <div class="accordion-element-detail" *ngIf="isMobile"
                    [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Principal Outstanding Before Settlement
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                <app-indian-currency-formatter [amount]="element.principalOutstandingBeforeSettlement">
                                </app-indian-currency-formatter>
                            </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Date of Settlement
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span> {{element.settlementDate}}</span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Gross Cashflow Received Post Settlement
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                <app-indian-currency-formatter amount="{{element.grossCashFlowReceivedPostSettlement}}">
                                </app-indian-currency-formatter>
                            </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Principal Written off Post Settlement
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                <app-indian-currency-formatter amount="{{element.settlementPrincipalWrittenOff}}">
                                </app-indian-currency-formatter>
                            </span>
                        </div>
                    </div>
                </div>
            </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns;" class="accordion-element-row"
            [class.accordion-expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element"></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="accordion-detail-row">
        </mat-row>

    </mat-table>
</div>
<div class="text-center margin-top-20" *ngIf="!networkCallInProgress && settlementDataSource.data.length === 0">
    <p><span>None of your investments have been settled.</span></p>
    <button mat-flat-button class="primary" type="button" [routerLink]="['/investordashboard']">
        BACK TO DASHBOARD
    </button>
</div>